/** Sidebar lists keep cached pages when switching tabs; only refetch on explicit refresh or filter change. */
export const SIDEBAR_OBSERVABILITY_QUERY_OPTIONS = {
  staleTime: 5 * 60 * 1000,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;
